<template>
    <!-- Phone -->
    <div class="oa-phone mr-[35px]">
        <div class="oa-phone-content"></div>

        <div class="flex oa-phone-menu flex-1">
            <div class="flex items-center justify-center oa-phone-menu-switch">
                <i class="el-icon-tickets"></i>
            </div>

            
                <div  v-for="(menuItem, index) in menuList" :key="index" >
                <div class="flex-1" style="position: relative;" @click="changeIndex(index)">
                    <!-- 一级菜单 -->
                    <div
                        class="flex items-center justify-center flex-1 text-sm oa-phone-menu-item"
                        :class="{ 'active-menu': menuIndex === index ,'noboder':index==2}" 
                    >
                        {{ menuItem.name }}
                    </div>

                    <!-- 二级菜单 -->
                    <div
                        class="oa-phone-menu-subitem"
                        v-show="menuItem.sub_button.length"
                    >
                      <template>
                        <div v-for="(subItem, index2) in menuItem.sub_button" :key="index2">
                            <div class="oa-phone-menu-subitem-title">
                                {{ subItem.name }}
                            </div>
                        </div>
                      </template>
                    </div>
                </div>
            </div>
        
            <!-- 新增菜单 -->
            <template v-if="menuList.length <= 2">
                <div class="flex items-center justify-center flex-1 h-full" @click="handleAddMenu">
                    <i class="el-icon-plus"></i>
                   
                </div>
            </template>
        </div>
    </div>
</template>
<script>
  export default {
    data() {
        return{
            i:0
            // menuList:[]
        }

    },
    props: {
        menuList: {
      type: Array,
      default: function () {
        return []
      }
    },
    menuIndex: {
      type: Number,
      default: 0
    }
   
  },
  watch:{
    menuList(){
        this.init()
    },
  },


    methods: {
        changeIndex(index){
            this.$emit('update:menuIndex', index)
        },
        init(){
            console.log(this.menuList,9090)
        },
        handleAddMenu(){
            this.menuList.push({
            name: '菜单名称',
            has_menu: false,
            type: 'view',
            url: '',
            appid: '',
            pagepath: '',
            sub_button: []
        })
        },
     
    }

  };
</script>
<style lang="scss" scoped>
.flex{
    display: flex;
} 
.items-center{
    align-items: center;
} 
.justify-center{
    justify-content: center;
} 
.flex-1{
    flex:1 1 0%；
} 
.text-sm{
    font-size: 13px;
} 
// .oa-phone-menu-item{
//     height: 100%;
//     border-right:1px solid #e5e5ea;

// }
.oa-phone {
    width: 260px;
    height: 461px;
    border: 1px solid #e5e5ea;
    flex: none;
    &-content {
        height: 420px;
        border-bottom: 1px solid #e5e5ea;
    }

    &-menu {
        height: 40px;
      
        cursor: pointer;

        &-switch {
            width: 40px;
            height: 100%;
            border-right: 1px solid #e5e5ea;
        }

        // 一级菜单
        &-item {
            height: 100%;
            // padding:10px ;
            height: 40px;
            line-height: 40px;
            padding:0 9px;
            flex:1;
            text-align: center;
            border-right: 1px solid #e5e5ea;
        }

        &-item:nth-child(4) {
            border-right: none;
        }

        .active-menu {
            position: relative;
        }

        .active-menu::after {
            content: '';
            width: 100%;
            height: 41px;
            top: -1px;
            position: absolute;
            border: 1px solid #4A5DFF;
        }

        // 二级菜单
        &-subitem {
            width: 98%;
            left: 2px;
            bottom: calc(100% + 10px);
            position: absolute;
            border: 1px solid #e5e5ea;
            border-top: none;

            &-title {
                height: 40px;
                line-height: 40px;
                text-align: center;
                border-top: 1px solid #e5e5ea;
            }
        }
    }
}
.noboder{
    border-right: none;
}
</style>



// WEBPACK FOOTER //
// src/views/appsetting/appmp/menu_com/oa-phone.vue